import { defineComponent as _defineComponent } from 'vue'
import {
  MissionContractPayment,
  InitiateClientPaymentProcessingMutation,
  InitiateClientPaymentProcessingMutationMutation,
  InitiateClientPaymentProcessingMutationMutationVariables,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { ref } from "vue"
import { useMissionLifecycleContext } from "../../hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmProcessingModal',
  props: {
    payment: null,
    isOpen: { type: Boolean },
    onClose: null
  },
  setup(__props: any) {

const props = __props as {
  payment: MissionContractPayment
  isOpen: boolean
  onClose: () => void
}

const isSubmitting = ref(false)



const { mutate: initiatePaymentProcessing } = useMutation()
const { addError, addSuccess } = useNotification()
const { refetchQueries } = useMissionLifecycleContext()

const onConfirm = async () => {
  isSubmitting.value = true

  const result = await initiatePaymentProcessing<
    InitiateClientPaymentProcessingMutationMutation,
    InitiateClientPaymentProcessingMutationMutationVariables
  >({
    variables: {
      paymentId: props.payment.prn,
    },
    mutation: InitiateClientPaymentProcessingMutation,
    refetchQueries,
  })

  isSubmitting.value = false

  if (result?.data?.initiateClientPaymentProcessing?.error) {
    addError(result.data.initiateClientPaymentProcessing.error.message)
    return
  }

  addSuccess("Payment processing started")
  props.onClose()
}

return { __sfc: true,isSubmitting, props, initiatePaymentProcessing, addError, addSuccess, refetchQueries, onConfirm }
}

})